import { CourseOffer, OccurrenceOffer, SelectedOffers } from '@shared/types';
import { FunctionComponent } from 'react';
import { QuantityCard } from '../QuantityCard';
import styles from './styles.module.scss';

export type OffersSelectProps = {
    name?: string;
    offers: Array<CourseOffer | OccurrenceOffer>;
    selectedOffers: SelectedOffers;
    availableSpaces: number;
    hidePricing?: boolean;
    setSelectedOffers: (selectedOffers: SelectedOffers) => unknown;
    currency: string;
};

export const OffersSelect: FunctionComponent<OffersSelectProps> = ({
    name = 'Available offers',
    offers,
    selectedOffers,
    availableSpaces,
    hidePricing,
    setSelectedOffers,
    currency,
}) => {
    return (
        <ul aria-label={name} className={styles.offersList}>
            {offers.map((offer) => {
                const value = selectedOffers[offer._id] || 0;
                const onChange = (newQuantity: number) => {
                    if (newQuantity === 0) {
                        const withoutOffer = { ...selectedOffers };
                        delete withoutOffer[offer._id];
                        return setSelectedOffers(withoutOffer);
                    }
                    setSelectedOffers({
                        ...selectedOffers,
                        [offer._id]: newQuantity,
                    });
                };
                return (
                    <li key={offer._id}>
                        <QuantityCard
                            name={offer.name || ''}
                            description={offer.description}
                            price={offer.price}
                            quantity={value}
                            maximumQuantity={value + availableSpaces}
                            hidePricing={hidePricing}
                            start_at={offer.start_at}
                            end_at={offer.end_at}
                            onChange={onChange}
                            currency={currency}
                        />
                    </li>
                );
            })}
        </ul>
    );
};
